<template>
    <workOrderProgress 
      title="生产主页"
      :show-quantity-column="false"
      :show-material-column="false"
      :work-order-data="workOrderData"
      :total-counts="totalCounts"
      :loading="loading"
      @get-data="handleGetData"
      @production-click="handleProductionClick"
      @design-click="handleDesignClick"


    />
</template>

<script>
import workOrderProgress from './workOrderProgress';
import { getWorkOrderHomeList} from '@/api/mainapi.js';
// import { getWorkOrderHomeList, UpdateDataList } from '@/api/mainapi.js';
// import UserInfoUtils from '@/utils/userInfoUtils.js';

export default {
  name: 'homeWorkOrders',
  props: {
    msg: String
  },
  components: {
    workOrderProgress
  },
  data() {
    return {
      // 筛选条件参数
      taskNoSearchKeyword: '', // 任务单筛选关键词
      productModelSearchKeyword: '', // 产品型号筛选关键词
      contractNoSearchKeyword: '', // 合同号筛选关键词
      departmentSearchKeyword: '', // 生产车间筛选关键词
      productionProgressSearchKeyword: '', // 生产进度筛选关键词
      commitDateSearchKeyword: '', // 下达日期筛选关键词
      planFinishDateSearchKeyword: '', // 计划完工日期筛选关键词
      isIssueSearchKeyword: '', // 是否有异常筛选
      qtySearchKeyword: '', // 数量筛选（对应接口字段 qty，数字类型）
      // 分页相关参数
      currentPage: 1,
      pageSize: 50,
      
      // 数据
      workOrderData: [],
      totalCounts: 0,
      loading: false
    };
  },
  mounted() {
    this.getWorkOrderList();
  },
  methods: {
    // 获取任务单列表
    async getWorkOrderList(pageNo = this.currentPage, pageSize = this.pageSize) {
      this.loading = true;
      
      const params = {
        taskNo: this.taskNoSearchKeyword || "",
        contractNo: this.contractNoSearchKeyword || "",
        model: this.productModelSearchKeyword || "",
        department: this.departmentSearchKeyword || "",
        productionProgress: this.productionProgressSearchKeyword || "",
        commitDate: this.commitDateSearchKeyword || "",
        planFinishDate: this.planFinishDateSearchKeyword || "",
        isIssue: this.isIssueSearchKeyword || "",
        pageNo: String(pageNo),
        pageSize: String(pageSize)
      };

      // 数量筛选：后端按 String 接收，直接传字符串（workOrderProgress 已保证是字符串）；未筛选时不传该字段
      if (this.qtySearchKeyword !== '' && this.qtySearchKeyword != null) {
        params.qty = String(this.qtySearchKeyword);
      }
      
      try {
        const res = await getWorkOrderHomeList(params);
        
        this.loading = false;
        
        if (res.data.code == 200) {
          const info = res.data.data.information;
          this.workOrderData = this.processWorkOrderData(info.list || []);
          this.totalCounts = info.total;
        } else {
          this.$message.error(res.data.message || '获取数据失败');
        }
      } catch (error) {
        this.loading = false;
        this.$message.error('网络错误，请检查连接');
      }
    },




    // 处理任务单数据
    processWorkOrderData(data) {
      if (!data || !Array.isArray(data)) return [];
      
      return data.map(item => {
        // 获取执行订单反馈的 context
        let feedbackContext = '';
        if (item['执行订单反馈'] && item['执行订单反馈'].context) {
          feedbackContext = item['执行订单反馈'].context;
        }
        
        // 获取派单时间的 dispatchDate
        let dispatchDate = '';
        if (item['派工日期'] && item['派工日期'].dispatchdate) {
          dispatchDate = this.formatDate(item['派工日期'].dispatchdate);
        }

        return {
          '任务号': item['任务号'] || '',
          '产品型号': item['FModel'] || '',
          '合同号': item['合同号'] || '',
          'BOM进度': item['BOM进度'] || '',
          // 数量：保留原始值，由 workOrderProgress 统一取整显示
          '数量': item['数量'] != null ? item['数量'] : '',
          // '设计人员': item['设计人员'] || '',
          // '加工图': item['加工图'] || '',
          // '小屋图纸': item['小屋图纸'] || '',
          // '装配图': item['装配图'] || '',
          // '防爆电器': item['防爆电器'] || '',
          // '机柜到货': item['机柜到货'] || '',
          '生产进度': item['生产进度'] || '',
          '生产车间': item['生产车间'] || '',
          '任务单执行反馈': feedbackContext,
          '派工日期': dispatchDate,
          '下达日期': this.formatDate(item['下达日期']) || '',
          '计划完工日期': this.formatDate(item['计划完工日期']) || '',
          '领料/投料': item['领料/投料'] || '0.0',
          '备注': item['备注'] || '',
          // '物料属性': item['物料属性'] || '',
          '在途数': item['在途数'] != null ? item['在途数'] : '',
          '可用库存': item['可用库存'] != null ? item['可用库存'] : '',
          '是否有异常': item['是否有异常'] || '',
        };
      });
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      
      if (dateString.length === 10) {
        return dateString;
      }
      
      if (dateString.length > 10) {
        return dateString.substring(0, 10);
      }
      
      return dateString;
    },
    
    // // 获取当前用户工号
    // getCurrentUserCode() {
    //   const userCode = UserInfoUtils.getUserCode();
    //   if (!userCode) {
    //     this.$message.warning('未获取到用户信息，请重新登录');
    //     this.$router.push('/login');
    //     return null;
    //   }
    //   return userCode;
    // },
    
    // 处理获取数据事件（包含分页和筛选）
    handleGetData(filters) {
      this.currentPage = filters.currentPage || 1;
      this.pageSize = filters.pageSize || 10;
      this.taskNoSearchKeyword = filters.taskNo || '';
      this.productModelSearchKeyword = filters.model || '';
      this.contractNoSearchKeyword = filters.contractNo || '';
      this.departmentSearchKeyword = filters.department || '';
      this.productionProgressSearchKeyword = filters.productionProgress || '';
      this.commitDateSearchKeyword = filters.commitDate || '';
      this.planFinishDateSearchKeyword = filters.planFinishDate || '';
      this.isIssueSearchKeyword = filters.isIssue || '';
      this.qtySearchKeyword = filters.qty != null ? filters.qty : '';
      
      this.getWorkOrderList();
    },
    
    // // 处理更新反馈事件
    // async handleUpdateFeedback(data) {
    //   try {
    //     const userCode = this.getCurrentUserCode();
    //     if (!userCode) return;

    //     // 构建请求数据
    //     const msgData = {
    //       taskNum: data.taskNum,
    //       updateBy: userCode,
    //       context: data.context
    //     };
        
    //     const jsonData = JSON.stringify(msgData);
    //     const params = {
    //       Type: 'UpdateTaskContent',
    //       msg: jsonData,
    //     };

    //     const res = await UpdateDataList(params);
        
    //     if (res.data.code === 200) {
    //       this.$message.success('反馈内容保存成功');
    //       this.getWorkOrderList(); // 重新获取数据
    //     } else {
    //       this.$message.error('保存失败：' + (res.data.message || '未知错误'));
    //     }
    //   } catch (error) {
    //     this.$message.error('网络错误，请检查连接');
    //   }
    // },
    
    // // 处理更新派工日期事件
    // async handleUpdateDispatchDate(data) {
    //   try {
    //     const userCode = this.getCurrentUserCode();
    //     if (!userCode) return;

    //     // 构建请求数据
    //     const msgData = {
    //       dispatchDate: data.dispatchDate,
    //       updateBy: userCode,
    //       taskNum: data.taskNum
    //     };
        
    //     const jsonData = JSON.stringify(msgData);
    //     const params = {
    //       Type: 'UpdateTaskInfo',
    //       msg: jsonData,
    //     };

    //     const res = await UpdateDataList(params);
        
    //     if (res.data.code === 200) {
    //       this.$message.success('派工日期保存成功');
    //       this.getWorkOrderList(); // 重新获取数据
    //     } else {
    //       this.$message.error('保存失败：' + (res.data.message || '未知错误'));
    //     }
    //   } catch (error) {
    //     this.$message.error('网络错误，请检查连接');
    //   }
    // },
    
    // 处理链接点击事件
    handleProductionClick(data) {
      this.goToProductProgressInfo(data);
    },
    
    // 跳转到生产详情页
    // goToProductProgressInfo(data) {
    //   this.$router.push(`/homepage/contract?id=${data.任务号}`);
    //   this.$EventBus.$emit('currentPath', '/homepage/contract');
    //   this.$EventBus.$emit('noContract', true);
    // }

    goToProductProgressInfo(data) {
      const workOrderId = data.任务号;
      const productModel = data['产品型号'] || '';

      // ✅ 产品型号存入 sessionStorage，生产页面可上查设计
      sessionStorage.setItem('production_model_from_home', productModel);

      this.$router.push({
        name: '任务生产信息',
        params: {
          workOrderId
        }
      });

      this.$EventBus.$emit('currentPath', '/homepage/workOrder/' + workOrderId); 
      this.$EventBus.$emit('noworkOrder', true);
    },

    // 处理链接点击事件
    handleDesignClick(data) {
      this.goToDesignProgressInfo(data);
    },


    goToDesignProgressInfo(data) {
      const workOrderId = data.任务号;
      const contractNo = data['合同号'] || '';
      const productModel = data['产品型号'] || '';

      // ✅ 任务单号和合同号存到 sessionStorage，设计页面从缓存取
      sessionStorage.setItem('design_current_workOrderId', workOrderId);
      sessionStorage.setItem('design_current_contractNo', contractNo);
      sessionStorage.setItem('design_source', 'taskOrder');
      // ✅ 产品型号存入 sessionStorage，生产页面可上查设计
      sessionStorage.setItem('production_model_from_home', productModel);
      // ✅ URL 只含 parentModel，合同号不显示在网址上
      this.$router.push({
        name: '任务设计信息',
        params: {
          parentModel: productModel || 'unknown'
        }
      });

      this.$EventBus.$emit('currentPath', '/homepage/workOrder/design/' + encodeURIComponent(productModel || 'unknown')); 
      this.$EventBus.$emit('noworkOrder', true);
    },




  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>